module.exports = function () {
    return function (input) {
        return (input) ? '/' + input.toLowerCase().trim().replace(/ > /g, '/').replace(/ /g, '-') : '';
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/bws-link-href.js
 **/